import {
  UserOutlined
} from "@ant-design/icons";
import { PageHeader } from "@ant-design/pro-components";
import { Auth } from "@aws-amplify/auth";
import { Avatar, Dropdown, Layout, MenuProps, notification } from "antd";
import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AppContext } from "../contexts/AppContext";
import path from "../utils/pathSettings";

const { Header } = Layout;

const HeaderApp = (): JSX.Element => {
  const { state: appContext, actionLogout } = useContext(AppContext);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("health_cognitouser") || "{}");
  const name = user?.signInUserSession?.idToken?.payload?.name ?? "";

  const contentMenu: MenuProps["items"] = [
    {
      key: path("profile"),
      label: (
        <Link to={path("profile")}>
          <b>{name}</b>
        </Link>
      ),
    },
    {
      key: path("settings"),
      label: <Link to={path("settings")}>Settings</Link>,
    },
    {
      key: "/logout",
      label: <div onClick={(e) => handleClick(e, "logout")}>Log Out</div>,
    },
  ];

  useEffect(() => {
    // console.log("appState: ", appState);
  }, []);

  const handleClick = async (e: React.MouseEvent<HTMLElement>, id: string) => {
    switch (id) {
      case "logout":
        await Auth.signOut();
        actionLogout();
        notification.success({
          message: "Log out successfully",
        });
        return;
      default:
    }
  };

  if (!appContext?.validLogin) {
    return <></>;
  } else {
    return (
      <Header className="header">
        {/* {React.createElement(
          collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
          {
            className: "trigger",
            onClick: () => setCollapsed(!collapsed),
          }
        )} */}
        <PageHeader
          onBack={() =>
            appContext.backButton === true
              ? appContext.backURL !== ""
                ? () => navigate(appContext.backURL)
                : () => window.history.back()
              : false
          }
          title={appContext.pageTitle}
          subTitle={appContext.pageSubtitle}
          extra={[
            <Dropdown
              menu={{ items: contentMenu }}
              trigger={["click"]}
              key={"profilepic"}
            >
              <Avatar className="avatar" icon={<UserOutlined />} src={""} />
            </Dropdown>,
          ]}
          backIcon={appContext?.backButton}
        // avatar={{ icon: <UserOutlined /> }}
        />
      </Header>
    );
  }
};

export default HeaderApp;
